var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { staticClass: "items-stretch", attrs: { id: "classes" } },
    [
      _c("div", { staticClass: "row fit", attrs: { id: "classes-interior" } }, [
        _c(
          "div",
          {
            staticClass: "col-auto",
            staticStyle: { width: "380px", position: "relative" }
          },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "text-primary text-center pane-text" },
                [
                  _c(
                    "q-field",
                    { attrs: { icon: "search" } },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": "Search by Affiliate / Instructor",
                          value: _vm.affiliateFilter,
                          clearable: true,
                          "clear-value": ""
                        },
                        on: {
                          keyup: function($event) {
                            $event.stopPropagation()
                            _vm.updateAffiliateFilter($event.target.value)
                          },
                          clear: function($event) {
                            _vm.updateAffiliateFilter("")
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "q-tree relative-position text-transparent",
                  staticStyle: { color: "black" },
                  attrs: { id: "tree" }
                },
                [
                  _vm._l(_vm.filteredAffiliates, function(affiliate, i) {
                    return _c(
                      "q-collapsible",
                      {
                        key: i,
                        class: {
                          selected: _vm.checkedInstructorsCount(affiliate) > 0
                        },
                        model: {
                          value: affiliate.open,
                          callback: function($$v) {
                            _vm.$set(affiliate, "open", $$v)
                          },
                          expression: "affiliate.open"
                        }
                      },
                      [
                        _c(
                          "template",
                          {
                            staticClass: "q-tree q-tree-node-parent",
                            slot: "header"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "q-tree-node-header relative-position row no-wrap items-center q-tree-node-link"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "row no-wrap items-center text-black"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "q-option cursor pointer no-outline row inline no-wrap items-center q-mr-xs q-focusable",
                                        attrs: { tabindex: i }
                                      },
                                      [
                                        _c("q-checkbox", {
                                          on: {
                                            input: function($event) {
                                              _vm.emitUpdateAffiliates({
                                                getAffiliates:
                                                  _vm.filteredAffiliates,
                                                affiliate:
                                                  affiliate.AFFILIATE_ID,
                                                selected: affiliate.selected
                                              })
                                            }
                                          },
                                          model: {
                                            value: affiliate.selected,
                                            callback: function($$v) {
                                              _vm.$set(
                                                affiliate,
                                                "selected",
                                                $$v
                                              )
                                            },
                                            expression: "affiliate.selected"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("span", {
                                      staticClass: "affiliate-name",
                                      attrs: {
                                        title: affiliate.AFFILIATE_NAME
                                      },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.highlightFilterMatch(
                                            affiliate.AFFILIATE_NAME
                                          )
                                        )
                                      }
                                    }),
                                    _vm.checkedInstructorsCount(affiliate) > 0
                                      ? _c(
                                          "q-chip",
                                          {
                                            attrs: {
                                              detail: "",
                                              square: "",
                                              dense: ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.checkedInstructorsCount(
                                                  affiliate
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        ),
                        !affiliate.INSTRUCTORS[0].USER_ID
                          ? _c("div", { staticClass: "no-results" }, [
                              _vm._v(
                                "\n                No Instructors Available.\n              "
                              )
                            ])
                          : _vm._e(),
                        affiliate.INSTRUCTORS[0].USER_ID
                          ? _c(
                              "div",
                              _vm._l(affiliate.INSTRUCTORS, function(
                                instructor,
                                ins
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: ins,
                                    staticClass:
                                      "q-tree-node-collapsible text-transparent"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "q-tree-children" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "q-tree-node q-tree-node-child"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "q-tree-node-header relative-position row no-wrap items-center"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "row no-wrap items-center text-black"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "q-option cursor-pointer no-outline row inline no-wrap items-center q-mr-xs q-focusable",
                                                        attrs: { tabindex: "0" }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "q-option-inner relative-position text-transparent"
                                                          },
                                                          [
                                                            _c("q-checkbox", {
                                                              attrs: {
                                                                title:
                                                                  instructor.USER_FIRST_NAME +
                                                                  " " +
                                                                  instructor.USER_LAST_NAME,
                                                                label: _vm.highlightFilterMatch(
                                                                  instructor.USER_FIRST_NAME +
                                                                    " " +
                                                                    instructor.USER_LAST_NAME
                                                                )
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  _vm.emitUpdateAffiliates(
                                                                    {
                                                                      getAffiliates:
                                                                        _vm.filteredAffiliates,
                                                                      instructor:
                                                                        instructor.INSTRUCTOR_ID,
                                                                      selected:
                                                                        instructor.selected
                                                                    }
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  instructor.selected,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    instructor,
                                                                    "selected",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "instructor.selected"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              })
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  }),
                  _vm.filteredAffiliates.length === 0
                    ? _c("div", { staticClass: "no-results" }, [
                        _vm._v(
                          "\n              No Matching results.\n            "
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ])
          ]
        ),
        _c("div", { staticClass: "col" }, [_c("Scheduler")], 1)
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }